import React from 'react';
import { Helmet } from 'react-helmet';

const SEOHead = ({ 
  title = "eSIM Myanmar - Instant Mobile Connectivity",
  description = "Get connected instantly with eSIM Myanmar. No physical SIM cards needed. Fast activation, reliable network coverage across Myanmar.",
  keywords = "eSIM, Myanmar, mobile connectivity, instant activation, travel SIM, digital SIM",
  url = "https://nexorasim-demo.pages.dev",
  image = "https://nexorasim-demo.pages.dev/og-image.jpg"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical */}
      <link rel="canonical" href={url} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "eSIM Myanmar",
          "url": url,
          "description": description,
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+95-1-234-5678",
            "contactType": "customer service"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEOHead;